let  timer: NodeJS.Timeout | null = null;

const timeout = (cb: () => void, delay: number) => {
  if (timer) {
    clearTimeout(timer);
  }

  timer = setTimeout(cb, delay);
}

export default timeout;